'use client'
import React from 'react'
import {motion} from 'framer-motion'
import SpinnerAnimationIcon from '@svg/spinnerAnimation.svg'

interface props {
  className?: string
  style?: any
  type?: 'button' | 'submit' | 'reset' | undefined
  variant?: Variant
  children: React.ReactNode
  onClick?: () => void
  loading?: boolean
  disabled?: boolean
  icon?: React.ReactNode
  postIcon?: React.ReactNode
  small?: boolean
}

export default function Button({
  className = '',
  type = 'button',
  variant,
  children,
  onClick,
  loading,
  disabled,
  icon,
  postIcon,
  small,
}: props) {
  const styles = {
    main: 'relative flex flex-row flex-nowrap gap-2 items-center justify-center h-fit py-2.5 px-4 rounded-lg font-medium text-sm sm:text-base',
    primary: 'bg-primary-400 text-on-primary ',
    secondary: 'bg-soft-100 text-on-secondary ',
    tertiary: 'bg-white text-on-background',
    plain: 'bg-transparent',
    outline: 'bg-background text-gray-900 shadow-[0px_0px_0px_1px_rgba(209,213,219,1),0px_1px_2px_0px_rgba(0,0,0,0.05)]',
    custom: 'pointer-events-auto',
  }

  const getClassName = (variant: Variant | undefined) => {
    if (styles?.[variant!]) return styles?.[variant!]
    return styles.primary
  }

  return (
    <motion.button
      type={type}
      layout
      whileHover={{scale: 1.02}}
      whileTap={{scale: 0.95}}
      onClick={() => (onClick ? onClick() : {})}
      className={`${styles.main} ${getClassName(variant)} ${className} ${small ? '!text-sm' : ''}`}
      disabled={disabled || loading}>
      {icon && <span className={'flex items-center aspect-square justify-center w-6 h-6'}>{icon}</span>}
      {children}
      {postIcon && <span className={'flex items-center aspect-square justify-center w-6 h-6'}>{postIcon}</span>}
      {loading && <SpinnerAnimationIcon className="size-4" />}
    </motion.button>
  )
}
